import { connect } from 'react-redux'

import {
  filterType,
  filterBedrooms,
  filterBudget,
  showAllFilters,
} from '../redux/modules/search/actions'

import ManageBookingFilterButton from '../components/ManageBookingFilterButton'

const mapStateToProps = (state) => ({
  downloadAllKeyinstructionsLink: state.search.downloadAllKeyInstructionsLink,
  manageGuestDetailsLink: state.search.manageGuestDetailsLink

})

const actionsCreators = {
  showAllFilters,
}

export default connect(mapStateToProps, actionsCreators)(ManageBookingFilterButton)



// WEBPACK FOOTER //
// ./src/containers/ManageBookingFilterButton.js